/* eslint-disable */ // TODO: fix lint errors and remove this comment

import {
  CustomShipmentText,
  TruncateWithTooltip,
  SearchInput,
} from '@/components';
import { Checkbox, Divider, Flex, message, Select, Tag, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import theme from '@/assets/theme';
import { ChevronDownIcon } from '@/assets/icons/icons';
//new changes are bieng implemented , working file [nisha]
const AlertRecipientSelector = ({
  alertType,
  form,
  loggedInUserId,
  recipientData,
  isRecipientsDropdownOpen,
  setIsRecipientsDropdownOpen,
  sendTeamsToParent,
  notificationMethod,
  showAdditionalTP = true,
  hideAdditionalRecipients = false,
  selectedRecipients,
  setSelectedRecipients,
  setRecipientsValues,
  setAdditional,
  recipientsValues,
  suffixIcon = undefined,
}) => {
  const [teamsData, setTeamsData] = useState([]);
  const [additionalRecipients, setAdditionalRecipients] = useState([]);
  const [selectedSingleRecipient, setSelectedSingleRecipient] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [filteredTeams, setFilteredTeams] = useState([]);
  const [filteredAdditional, setFilteredAdditional] = useState([]);
  const [expandedTeams, setExpandedTeams] = useState({});
  const isOneTime = alertType === 'ONE_TIME';
  const isOneTimeAI =
    isOneTime && ['AI_EMAIL', 'AI_CALL'].includes(notificationMethod);
  const shouldShowControllingOffice =
    alertType === 'CRITICAL_ALERT' &&
    (!notificationMethod || ['EMAIL', 'AI_EMAIL'].includes(notificationMethod));

  const selectedAiActionType = Form.useWatch('ai_action_type', form);
  const shouldShowActionInitiator =
    alertType === 'AI_ACTION' && [2, 3, 4].includes(selectedAiActionType);

  const getIsUserDisabled = (user, teamId, permissions) => {
    const selectedNotifyVia = form.getFieldValue('notification_method');
    const shouldEnforceRecipientOptIn =
      selectedNotifyVia && selectedNotifyVia !== 'AI_CALL';
    const notifyOptionIsFalse =
      shouldEnforceRecipientOptIn &&
      user.notification_options?.[selectedNotifyVia] === false;
    const isGloballyDisabled =
      isOneTimeAI &&
      selectedSingleRecipient &&
      selectedSingleRecipient !== `${teamId}::${user.id}`;

    return (
      isGloballyDisabled ||
      notifyOptionIsFalse ||
      (permissions.create_self && user.email !== loggedInUserId) ||
      notificationMethod === 'SLACK' ||
      notificationMethod === 'TEAMS'
    );
  };

  useEffect(() => {
    setTeamsData((prev) =>
      prev.map((team) => {
        const allMembersKey = `${team.id}::ALL_MEMBERS`;
        const isAllSelected = selectedRecipients.includes(allMembersKey);

        const updatedUsers = Array.isArray(team.users)
          ? team.users.map((user) => {
              const disabled = getIsUserDisabled(
                user,
                team.id,
                team.permissions
              );
              return {
                ...user,
                is_checked:
                  !disabled &&
                  (isAllSelected ||
                    selectedRecipients.includes(`${team.id}::${user.id}`)),
              };
            })
          : [];

        return {
          ...team,
          select_all: isAllSelected,
          users: updatedUsers,
        };
      })
    );
  }, [selectedRecipients, notificationMethod, selectedSingleRecipient]);

  useEffect(() => {
    if (shouldShowActionInitiator) return;

    const actionInitiatorKey = 'ACTION_INITIATOR';

    if (selectedRecipients?.includes(actionInitiatorKey)) {
      setSelectedRecipients((prev) =>
        prev.filter((item) => item !== actionInitiatorKey)
      );
    }
    if (setAdditional) {
      setAdditional((prev) =>
        prev.filter((item) => item !== actionInitiatorKey)
      );
    }
  }, [
    shouldShowActionInitiator,
    selectedRecipients,
    setSelectedRecipients,
    setAdditional,
  ]);

  useEffect(() => {
    if (shouldShowControllingOffice) return;

    const controllingOfficeKey = 'CONTROLLING_OFFICE_PRIMARY_CONTACT';

    if (selectedRecipients?.includes(controllingOfficeKey)) {
      setSelectedRecipients((prev) =>
        prev.filter((item) => item !== controllingOfficeKey)
      );
    }
    if (setAdditional) {
      setAdditional((prev) =>
        prev.filter((item) => item !== controllingOfficeKey)
      );
    }
  }, [
    shouldShowControllingOffice,
    selectedRecipients,
    setSelectedRecipients,
    setAdditional,
  ]);
  const css = {
    additionalRow: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      padding: '8px 16px',
    },
  };

  useEffect(() => {
    if (recipientData) {
      const additionalOptions = recipientData?.additional || [];
      let formattedAdditionalOptions = additionalOptions.map((item) => ({
        value: item.key,
        label:
          item?.label?.toLowerCase() === 'transport provider primary contact'
            ? `${theme.themeType === 2 ? 'Carrier primary contact' : item?.label}`
            : item?.label,
        disabled: !item.enabled,
      }));

      formattedAdditionalOptions = formattedAdditionalOptions.filter((item) => {
        if (item.value === 'ACTION_INITIATOR') {
          return shouldShowActionInitiator;
        }
        // Controlling office is Alert event (any alert type) + email only (not Status/ETA/etc. or OTN).
        if (item.value === 'CONTROLLING_OFFICE_PRIMARY_CONTACT') {
          return shouldShowControllingOffice;
        }
        return true;
      });

      if (hideAdditionalRecipients) {
        formattedAdditionalOptions = [];
      } else if (!showAdditionalTP && formattedAdditionalOptions?.length > 0) {
        formattedAdditionalOptions = formattedAdditionalOptions.filter(
          (x) => x.value !== 'TRANSPORT_PROVIDER_PRIMARY_CONTACT'
        );
      }

      setAdditionalRecipients(formattedAdditionalOptions);

      const sortedList = Array.isArray(recipientData?.teams_users)
        ? [...recipientData.teams_users].sort((a, b) => {
            const nameA = a?.name?.toLowerCase?.() || '';
            const nameB = b?.name?.toLowerCase?.() || '';
            const isADefault = nameA === 'default';
            const isBDefault = nameB === 'default';

            if (isADefault && !isBDefault) return -1;
            if (!isADefault && isBDefault) return 1;
            return 0;
          })
        : [];

      const teamList = sortedList.map((team) => {
        const allMembersKey = `${team.id}::ALL_MEMBERS`;
        const isAllSelected = selectedRecipients.includes(allMembersKey);

        const updatedUsers = Array.isArray(team.users)
          ? team.users.map((user) => {
              const disabled = getIsUserDisabled(
                user,
                team.id,
                team.permissions,
                team.slack_connected,
                team.teams_webhook
              );
              return {
                ...user,
                is_checked:
                  !disabled &&
                  (isAllSelected ||
                    selectedRecipients.includes(`${team.id}::${user.id}`)),
              };
            })
          : [];

        return {
          ...team,
          select_all: isAllSelected,
          users: updatedUsers,
        };
      });
      setTeamsData(teamList);
      sendTeamsToParent(teamList);
    }
  }, [
    recipientData,
    alertType,
    hideAdditionalRecipients,
    showAdditionalTP,
    selectedRecipients,
    notificationMethod,
    selectedSingleRecipient,
    shouldShowControllingOffice,
    shouldShowActionInitiator,
  ]);
  useEffect(() => {
    if (!recipientData) return;

    if (selectedAiActionType && alertType === 'AI_ACTION') {
      const additionalOptions = recipientData?.additional || [];

      let filtered = additionalOptions
        .map((item) => ({
          value: item.key,
          label:
            item?.label?.toLowerCase() === 'transport provider primary contact'
              ? `${theme.themeType === 2 ? 'Carrier primary contact' : item?.label}`
              : item?.label,
          disabled: !item.enabled,
        }))
        .filter((item) => {
          if (item.value === 'ACTION_INITIATOR') {
            return shouldShowActionInitiator;
          }
          if (item.value === 'CONTROLLING_OFFICE_PRIMARY_CONTACT') {
            return shouldShowControllingOffice;
          }
          return true;
        });

      if (!showAdditionalTP && filtered?.length > 0) {
        filtered = filtered.filter(
          (x) => x.value !== 'TRANSPORT_PROVIDER_PRIMARY_CONTACT'
        );
      }

      setAdditionalRecipients(filtered);
    }
  }, [
    selectedAiActionType,
    alertType,
    notificationMethod,
    showAdditionalTP,
    shouldShowActionInitiator,
    shouldShowControllingOffice,
  ]);
  useEffect(() => {
    setFilteredTeams(teamsData);
    setFilteredAdditional(additionalRecipients);
  }, [teamsData, additionalRecipients]);

  const onToggleChange = (event, id) => {
    const team = teamsData.find((t) => t.id === id);
    const teamObj = JSON.parse(JSON.stringify(team));
    teamObj.create_self = teamObj?.permissions?.create_self || false;
    teamObj.select_all = event;
    team.select_all = event;
    let formValues = recipientsValues;
    if (team.users.length > 0) {
      team.users.forEach((element) => {
        const disabled = getIsUserDisabled(element, team.id, team.permissions);
        element.is_checked = disabled ? false : event;
      });
    }

    let currentValues = selectedRecipients;
    currentValues = selectedRecipients.filter((x) => {
      if (x.includes('::')) {
        return x.split('::')[0] !== teamObj.id;
      }
      return true;
    });

    let updatedValues = [];
    if (event) {
      teamObj.users = [];
      updatedValues = [...new Set([...currentValues, `${id}::ALL_MEMBERS`])];
      const ind = formValues.findIndex((x) => x.id === teamObj.id);
      if (ind === -1) {
        formValues.push(teamObj);
      } else {
        formValues[ind] = teamObj;
      }
    } else {
      updatedValues = currentValues.filter((x) => x !== `${id}::ALL_MEMBERS`);
      formValues = formValues.filter((x) => x.id !== teamObj.id);
    }
    setSelectedRecipients(updatedValues);
    setRecipientsValues(formValues);
  };

  const filterOptions = (e) => {
    const val = e?.toLowerCase();
    setSearchValue(val);

    if (!val) {
      setFilteredTeams(teamsData);
      setFilteredAdditional(additionalRecipients);
      return;
    }

    const filteredAdditionalList = additionalRecipients.filter((item) =>
      item.label.toLowerCase().includes(val)
    );

    const filteredTeamsList = teamsData
      .map((team) => {
        const teamMatches = team.name.toLowerCase().includes(val);

        const matchedUsers = team.users.filter(
          (user) =>
            user.name?.toLowerCase().includes(val) ||
            user.email?.toLowerCase().includes(val)
        );

        if (teamMatches) {
          return { ...team };
        } else if (matchedUsers.length > 0) {
          return { ...team, users: matchedUsers };
        }

        return null;
      })
      .filter(Boolean);

    setFilteredTeams(filteredTeamsList);
    setFilteredAdditional(filteredAdditionalList);
  };

  const handleClear = () => {
    setSearchValue('');
    setFilteredTeams(teamsData);
    setFilteredAdditional(additionalRecipients);
  };

  const toggleTeamExpand = (id) => {
    setExpandedTeams((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleCheckboxChange = (e, user, id) => {
    let values = [...selectedRecipients];
    let updatedFormValues = [...recipientsValues];
    let teamObj = null;
    const val = e.target.checked;

    user.is_checked = val;

    const data = teamsData.find((x) => x.id === id);
    if (!data) {
      return;
    }

    // Individual user selection should never auto-enable select all
    data.select_all = false;

    teamObj = JSON.parse(JSON.stringify(data));
    teamObj.create_self = teamObj?.permissions?.create_self || false;
    teamObj.select_all = false;

    let users = data.users.filter((x) => x.is_checked).map((x) => x.id);
    teamObj.users = users;

    data.users.forEach((element) => {
      const valueKey = `${id}::${element.id}`;
      if (element.is_checked) {
        if (!values.includes(valueKey)) values.push(valueKey);
      } else {
        values = values.filter((r) => r !== valueKey);
      }
    });

    // Never keep ALL_MEMBERS when selection is happening user-by-user
    if (values.includes(`${id}::ALL_MEMBERS`)) {
      values = values.filter((x) => x !== `${id}::ALL_MEMBERS`);
    }

    const existingIndex = updatedFormValues.findIndex(
      (x) => x.id === teamObj.id
    );

    if (existingIndex !== -1) {
      updatedFormValues[existingIndex] = teamObj;
    } else {
      updatedFormValues.push(teamObj);
    }

    updatedFormValues = updatedFormValues.filter(
      (x) => !(!x.select_all && x?.users?.length === 0)
    );

    setRecipientsValues(updatedFormValues);
    setSelectedRecipients(values);
  };

  const handleAdditionalCheckboxChange = (e, option) => {
    let values = [...selectedRecipients];
    if (e.target.checked) {
      if (!values.includes(option)) {
        values.push(option);
      }
    } else {
      values = values.filter((c) => c !== option);
    }
    let additionalRecipients = [];
    values.forEach((element) => {
      if (!element.includes('::')) {
        if (additionalRecipients.findIndex((x) => x === element) === -1) {
          additionalRecipients.push(element);
        }
      }
    });
    setSelectedRecipients(values);
    if (setAdditional) {
      setAdditional(additionalRecipients);
    }
  };

  return (
    <>
      <Select
        mode='multiple'
        placeholder='Select...'
        value={selectedRecipients}
        allowClear
        onChange={(newValue) => {
          if (!newValue || newValue.length === 0) {
            setSelectedRecipients([]);
            setRecipientsValues([]);
            if (setAdditional) {
              setAdditional([]);
            }
          }
        }}
        optionLabelProp='label'
        className='custom-optgroup-label reciepent-selector-dropdown'
        suffixIcon={suffixIcon}
        virtual={false}
        open={isRecipientsDropdownOpen}
        onDropdownVisibleChange={(open) => {
          const hasNotifyVia = !!form.getFieldValue('notification_method');
          if (open && !hasNotifyVia) {
            message.error("Please select 'Notify via' first.");
            setIsRecipientsDropdownOpen(false);
          } else {
            setIsRecipientsDropdownOpen(open);
          }
        }}
        tagRender={({ label, onClose, value }) => {
          const tagTeamId = value?.includes('::') ? value.split('::')[0] : null;
          const tagDotColor = tagTeamId
            ? teamsData.find((t) => t.id === tagTeamId)?.color || '#000000'
            : null;
          return (
            <Tag
              className='notification-filter-tag multi-select-tag'
              closable
              onClose={(e) => {
                e.preventDefault();
                if (value) {
                  if (value.includes('::')) {
                    const [teamId, userId] = value.split('::');
                    let formValues = [...recipientsValues];
                    const teamObj = teamsData.find((x) => x.id === teamId);
                    const formTeamIndex = formValues.findIndex(
                      (t) => t.id === teamId
                    );

                    if (userId !== 'ALL_MEMBERS') {
                      if (formTeamIndex > -1) {
                        if (formValues[formTeamIndex]?.users?.length > 0) {
                          formValues[formTeamIndex].users = formValues[
                            formTeamIndex
                          ].users.filter((u) => u !== userId);
                        }

                        if (formValues[formTeamIndex]?.users?.length === 0) {
                          formValues = formValues.filter(
                            (obj) => obj.id !== teamId
                          );
                        }
                      }

                      if (teamObj?.users?.length > 0) {
                        const userIndex = teamObj.users.findIndex(
                          (x) => x.id === userId
                        );
                        if (userIndex > -1) {
                          teamObj.users[userIndex].is_checked = false;
                        }
                      }
                    }

                    if (userId === 'ALL_MEMBERS') {
                      formValues = formValues.filter(
                        (obj) => obj.id !== teamId
                      );
                      teamObj.select_all = false;
                      if (teamObj?.users?.length > 0) {
                        teamObj.users.forEach((ele) => {
                          ele.is_checked = false;
                        });
                      }
                    }
                    setRecipientsValues(formValues);
                  } else {
                    if (setAdditional) {
                      setAdditional((prev) =>
                        prev.filter((val) => val !== value)
                      );
                    }
                  }
                  setSelectedRecipients((prev) =>
                    prev.filter((val) => val !== value)
                  );
                }
                onClose?.(e);
              }}
            >
              <Flex align='center' gap={6}>
                {tagDotColor && (
                  <span
                    className='team-color-dot'
                    style={{ backgroundColor: tagDotColor }}
                  />
                )}
                <TruncateWithTooltip
                  text={String(label)}
                  max={25}
                  render={(t) => <span>{t}</span>}
                />
              </Flex>
            </Tag>
          );
        }}
        dropdownRender={(menu) => (
          <div className='reciepent-selector-dropdown-wrapper'>
            <div className='my-2 mx-4'>
              <SearchInput
                placeholder='Search recipients...'
                value={searchValue}
                onChange={filterOptions}
                width='100%'
                onClear={handleClear}
              />
            </div>
            <Divider className='divider margin-8' />
            {menu}
          </div>
        )}
      >
        {!hideAdditionalRecipients &&
          filteredAdditional.map((option) => {
            const isDisabled =
              option.disabled ||
              (isOneTimeAI &&
                selectedSingleRecipient &&
                selectedSingleRecipient !== option.value);
            const isChecked = selectedRecipients.includes(option.value);

            const handleAdditionalRowClick = (e) => {
              if (isDisabled) return;
              e.preventDefault();
              e.stopPropagation();
              const tempEvent = { target: { checked: !isChecked } };
              handleAdditionalCheckboxChange(tempEvent, option.value);
            };

            return (
              <Select.Option
                key={option.value}
                value={option.value}
                label={option.label}
                disabled={isDisabled}
                className='reciepent-user-selection for-reports-filters-selection'
                style={{
                  padding: 0,
                }}
              >
                <div
                  onMouseDown={(e) => {
                    e.preventDefault();
                  }}
                  onClick={handleAdditionalRowClick}
                  style={{
                    ...css.additionalRow,
                    color: isDisabled ? '#B0B0B0' : '#000',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  <Checkbox
                    className='checkbox-md'
                    checked={isChecked}
                    disabled={isDisabled}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) =>
                      handleAdditionalCheckboxChange(e, option.value)
                    }
                  >
                    <CustomShipmentText text={option?.label} />
                  </Checkbox>
                </div>
              </Select.Option>
            );
          })}

        {filteredTeams?.map(
          ({
            id,
            name,
            users,
            permissions,
            select_all,
            color,
            slack_connected,
            teams_webhook,
          }) => {
            const isSwitchDisabled =
              isOneTimeAI ||
              !permissions.is_create ||
              permissions.create_self ||
              (notificationMethod === 'SLACK' && !slack_connected) ||
              (notificationMethod === 'TEAMS' && !teams_webhook);
            const fullTeamUsers =
              teamsData.find((t) => t.id === id)?.users || [];
            const checkedUsersCount = fullTeamUsers.filter(
              (u) => u.is_checked
            ).length;
            const isTeamIndeterminate =
              !select_all &&
              checkedUsersCount > 0 &&
              checkedUsersCount < fullTeamUsers.length;
            const hasTeamUsers = fullTeamUsers.length > 0;
            const isTeamExpanded = !!searchValue || !!expandedTeams[id];
            const handleTeamLabelClick = (e) => {
              if (isSwitchDisabled) return;
              e.preventDefault();
              e.stopPropagation();
              onToggleChange(!select_all, id);
            };

            return (
              <React.Fragment key={id}>
                <Select.Option
                  key={`${id}::ALL_MEMBERS`}
                  value={`${id}::ALL_MEMBERS`}
                  label={`All members of ${name}`}
                  disabled
                  className='hide-checkmark-ant-select'
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: 'var(--light-gray)',
                    color:
                      isOneTimeAI ||
                      !permissions.is_create ||
                      permissions.create_self ||
                      users.length === 0
                        ? '#B0B0B0'
                        : '#000',
                    paddingLeft: '16px',
                    borderRadius: 0,
                    cursor: 'default',
                  }}
                >
                  <Flex
                    justify='space-between'
                    align='center'
                    onMouseDown={(e) => {
                      e.preventDefault();
                    }}
                  >
                    {/* teams checkbox  */}
                    <Flex
                      align='center'
                      gap={4}
                      onClick={handleTeamLabelClick}
                      style={{
                        cursor: isSwitchDisabled ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <Checkbox
                        className='checkbox-md team-select-all-checkbox mr-2'
                        checked={select_all}
                        indeterminate={isTeamIndeterminate}
                        disabled={isSwitchDisabled}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => onToggleChange(e.target.checked, id)}
                      />
                      <Flex align='center' gap={8}>
                        <span
                          className='team-color-dot'
                          style={{ backgroundColor: color || '#F6BC2F' }}
                        />
                        <TruncateWithTooltip
                          text={String(name)}
                          max={25}
                          render={(t) => (
                            <CustomShipmentText
                              text={t}
                              fontWeight={600}
                              color={isSwitchDisabled ? '#B0B0B0' : '#333'}
                            />
                          )}
                        />
                      </Flex>
                    </Flex>
                    {hasTeamUsers ? (
                      <span
                        role='button'
                        aria-label={`Toggle ${name} members`}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          toggleTeamExpand(id);
                        }}
                        className='cursor-pointer'
                      >
                        <ChevronDownIcon
                          size={16}
                          color='var(--text-secondary)'
                          style={{
                            transform: isTeamExpanded
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                            transition: 'transform 0.2s ease',
                          }}
                        />
                      </span>
                    ) : (
                      <CustomShipmentText
                        text={'No users'}
                        color='var(--text-secondary)'
                      />
                    )}
                  </Flex>
                </Select.Option>

                {users.map((user) => {
                  const isDisabled = getIsUserDisabled(user, id, permissions);

                  const valueKey = `${id}::${user.id}`;

                  const handleRowClick = (e) => {
                    if (isDisabled) return;
                    e.preventDefault();
                    e.stopPropagation();

                    const tempEvent = { target: { checked: !user.is_checked } };
                    handleCheckboxChange(tempEvent, user, id);
                  };

                  return (
                    <Select.Option
                      key={valueKey}
                      value={valueKey}
                      label={user.name || user.email || user.id}
                      disabled={isDisabled}
                      className='reciepent-user-selection for-reports-filters-selection'
                      style={{
                        padding: 0,
                        display: isTeamExpanded ? undefined : 'none',
                      }}
                    >
                      <Flex
                        align='center'
                        gap={4}
                        onMouseDown={(e) => {
                          e.preventDefault();
                        }}
                        onClick={handleRowClick}
                        style={{
                          ...css.additionalRow,
                          color: isDisabled ? '#B0B0B0' : '#000',
                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                        }}
                      >
                        {/* users checkbox */}
                        <Checkbox
                          className='checkbox-md mr-2'
                          checked={!isDisabled && !!user.is_checked}
                          disabled={isDisabled}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => handleCheckboxChange(e, user, id)}
                        />

                        <Flex align='center' gap={8}>
                          <span
                            className='team-color-dot'
                            style={{
                              opacity: isDisabled ? 0.5 : 1,
                              backgroundColor: color || '#F6BC2F',
                            }}
                          />
                          <CustomShipmentText
                            text={user.name || user.email || user.id}
                            color={isDisabled ? '#B0B0B0' : '#000'}
                          />
                        </Flex>
                      </Flex>
                    </Select.Option>
                  );
                })}
              </React.Fragment>
            );
          }
        )}
      </Select>
    </>
  );
};

export default AlertRecipientSelector;
